export default {"src":"/_next/static/image/public/images/flags/flag_992.27097ca3291c1fd21d2de655ff53a282.svg","height":16,"width":24};